import styled from 'styled-components';

const StyledLuggageTable = styled.div`
  display: grid;
`;
const StyledLuggageTableRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  padding: 0.875rem 0;

  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    border-bottom: 2px solid ${(props) => props.theme.color.borderColor};
  }
`;
const StyledLuggageType = styled.div`
  grid-column: span 3;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const StyledLuggageDetails = styled.div`
  grid-column: span 3;
`;
const StyledLuggagePrice = styled.div`
  grid-column: span 1;
  margin-left: auto;
`;

const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 1rem;
  height: 1rem;
  border: 2px solid ${(props) => props.theme.color.bodyTextColor};
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  position: relative;

  &:checked {
    background-color: ${(props) => props.theme.color.bodyTextColor};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.theme.color.bodyTextColor};
    border-radius: 50%;
  }
`;

export {
  StyledCheckbox,
  StyledLuggageTable,
  StyledLuggageDetails,
  StyledLuggagePrice,
  StyledLuggageTableRow,
  StyledLuggageType,
};
